<template>
<!-- Login Banner -->
<div class="col-md-6 login-bg d-none d-lg-flex">
    <div class="login-carousel">
        <div>
            <div class="login-carousel-section mb-3">
                <div class="login-banner">
                    <img src="@/assets/img/auth/auth-1.svg" class="img-fluid" alt="Logo">
                </div>
                <Carousel>
                    <Slide v-for="slide in slides" :key="slide.key">
                        <div class="mentor-course text-center">
                            <h3 class="mb-2" v-html="slide.title"></h3>
                            <p>{{ slide.description }}</p>
                        </div>
                    </Slide>
                    <template #addons>
                        <Pagination />
                    </template>
                </Carousel>
            </div>
        </div>
    </div>
</div>
<!-- /Login Banner -->
</template>
<script>
    import { defineComponent } from 'vue'
    import { Carousel, Pagination, Slide } from 'vue3-carousel';
    
    import 'vue3-carousel/dist/carousel.css';
    
    export default defineComponent({
    name: 'Autoplay',
    components: {
    Carousel,
    Slide,
    Pagination,
    },
    data() {
        return {
            slides: [
                {
                    key: 'welcome',
                    title: 'Selamat datang di <br />Sapta<span class="text-secondary">LMS</span> eLearning',
                    description: 'Platform pembelajaran internal PT Sapta Tunas Teknologi untuk mengelola materi, pelatihan, dan progres belajar karyawan secara terstruktur.',
                },
                {
                    key: 'learning',
                    title: 'Belajar lebih mudah dengan <br />Sapta<span class="text-secondary">LMS</span>',
                    description: 'Akses modul kapan saja, ikuti pelatihan sesuai kebutuhan peran, dan pantau progres belajar dalam satu dashboard.',
                },
                {
                    key: 'growth',
                    title: 'Tingkatkan kompetensi <br />bersama Sapta<span class="text-secondary">LMS</span>',
                    description: 'Bangun skill melalui materi terkurasi, evaluasi, dan sertifikat untuk mendukung pengembangan karier.',
                },
            ],
        };
    },
});
</script>
